import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './CustomCursor.css';

const CustomCursor = () => {
  const cursorRef = useRef(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    if (!cursor) return undefined;

    const handleMove = (e) => {
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;
    };

    window.addEventListener('mousemove', handleMove, { passive: true });

    return () => {
      window.removeEventListener('mousemove', handleMove);
    };
  }, []);

  return createPortal(
    <div ref={cursorRef} className="custom-cursor" aria-hidden="true" />,
    document.documentElement,
  );
};

export default CustomCursor;
